//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgCopy } from '../icons/Copy';

export function CopyIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgCopy} data-qa="CopyIcon">
      <svg />
    </SvgIcon>
  );
}
